(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.MarketPlace.ElevateLifeAssets.Taylor",
                {
                    url: "/Taylor",
                    component: "e4ltaylor",
                    PageTitle: "Elevate for Life - Eszylfie Taylor"
                });
        }
    ]);

    app.component("e4ltaylor",
        {
            templateUrl: "App/Tools/MarketPlace/ElevateLifeAssets/Taylor/Taylor.html",
            controller: e4LTaylorCtrl,
            bindings: {
            }
        });

    e4LTaylorCtrl.$inject = ["$timeout", "$state", "$mdDialog", "$filter", "ssoApi", "externalLoading"];

    function e4LTaylorCtrl($timeout, $state, $mdDialog, $filter, ssoApi, externalLoading) {
        var $ctrl = this;

        this.ActivateTaylorMethodSso = function () {
            var w = window.open();
            w.document.write(externalLoading.html);
            ssoApi.initiateTaylorMethodSso().then(function (data) {
                //console.log(data);          
                w.document.write(data);
                w.document.forms.samlform.submit();
            }, function () {
                w.document.write(" Failed.  There was an error accessing this resource.");
            });
        }

    }

})(window.app);